export default "__VITE_ASSET__DmbuQXpS__"